mutation RetryQueueJobMutation($queueName: String!, $id: ID!) {
  retryQueueJob(queueName: $queueName, id: $id) {
    id
    state
    progress
    attemptsMade
    failedReason
    finishedOn
    processedOn
  }
}
